/* eslint-disable prettier/prettier */
import React from 'react';
import { GetPedidos } from '../../utils/api/api';
import './styles.css';
import { toast } from 'react-toastify';
import { GlobalContext } from '../../contexts/HomeContext';
import { Capitalize, FormataValor, FormatDateTime } from '../../utils/utils';
import { Button } from '../Button';
import { ValoresTotais } from '../ValoresTotais';
import { Modal } from '../Modal';
import Timeline from '../Timeline';
import QRCode from 'react-qr-code';
import { useLocation } from 'react-router';
import { IVendas, IPedidoSelecionadoType, IPedidoType } from '../../Types/index';

const PedidoDefault = () => {
  return {
    numero_pedido: 0,
    data: '',
    datahora_pedido: '',
    importado_data: '',
    senha_pedido: '',
    total: 0,
    previsao: '',
    endereco: '',
    confirmado: false,
    online: [false],
    pagamento: [''],
  };
};

type Props = {
  param: any;
};

const Pedidos: React.FC<Props> = ({ param }) => {
  const { user, dadosApp } = React.useContext(GlobalContext);
  const [isLoading, setIsLoading] = React.useState(true);
  const [PEDIDOS, setPedidos] = React.useState<IPedidoType>();
  const firstEntrance = React.useRef(true);
  const search = useLocation().search;
  const modulo = new URLSearchParams(search).get('modulo');
  const [pedidoSelecionado, setPedidoSelecionado] = React.useState<IPedidoSelecionadoType>(PedidoDefault);
  const element = document.querySelector('.modal-content');
  const QRCodeValue =
    dadosApp.TipoApp !== 'BALCAO'
      ? PEDIDOS?.Detalhes.filter((p) => p.Produto.numero_pedido == pedidoSelecionado.numero_pedido).slice(0, 1)[0] // eslint-disable-next-line prettier/prettier
        ?.qrCode
      : '';

  // calcula o total
  let total = 0;
  let taxa = 0;
  let subTotal = 0;
  const calculaTotais = PEDIDOS?.Detalhes.filter((p) => p.Produto.numero_pedido == pedidoSelecionado.numero_pedido).map(
    (item) => {
      subTotal += item.VTotal;
      taxa += item.VServico;
      total += item.VTotal + item.VServico;
      return { subTotal: subTotal, taxa: taxa, total: total };
    },
  );

  const pix = pedidoSelecionado?.pagamento ? pedidoSelecionado?.pagamento[0]?.toUpperCase() === 'PIX' : false;
  const pago = pix
    ? pedidoSelecionado?.dadosPix && pedidoSelecionado?.dadosPix[0]?.pago === 1
    : pedidoSelecionado?.online // eslint-disable-next-line prettier/prettier
      ? pedidoSelecionado?.online[0] // eslint-disable-next-line prettier/prettier
      : false;

  const handlePrevisao = React.useCallback(
    (data_pedido: string, short = true) => {
      const previsao = dadosApp.Empresa.Config.previsao_entrega | 0;
      const date = new Date(data_pedido);

      date.setMinutes(date.getMinutes() + previsao);

      if (short) {
        return date.toLocaleTimeString('pt-BR', {
          hour: '2-digit',
          minute: '2-digit',
        });
      } else {
        return date;
      }
    },
    [dadosApp.Empresa.Config.previsao_entrega],
  );

  const handleItemSelected = React.useCallback(
    (item: IVendas) => {
      setPedidoSelecionado({
        numero_pedido: item.numero_pedido,
        data: new Date(item.datahora_pedido).toLocaleString(),
        datahora_pedido: item.datahora_pedido,
        importado_data: item.importado_data,
        senha_pedido: item.senha_pedido,
        total: item.total_com_servico,
        previsao:
          item.importado === 1
            ? handlePrevisao(item.importado_data, false)
            : handlePrevisao(item.datahora_pedido, false),
        endereco: item.endereco + ', ' + item.endereco_numero + ' - ' + item.bairro,
        confirmado: item.importado > 0 && item.importado !== 99,
        online: PEDIDOS?.Pagamento.filter((p) => p.numero_pedido === item.numero_pedido).map((p) => {
          return p.pago_online === 1;
        }),
        pagamento: PEDIDOS?.Pagamento.filter((p) => p.numero_pedido === item.numero_pedido).map((p) => {
          return p.pago_online == 1 ? '**** **** **** ' + p.descricao : p.descricao;
        }),
        dadosPix: PEDIDOS?.PagOnline.filter((p) => p.numero_pedido === item.numero_pedido).map((p) => {
          return p;
        }),
      });
      if (element) element.scrollTo({ top: 0 });
    },
    [PEDIDOS?.PagOnline, PEDIDOS?.Pagamento, element, handlePrevisao],
  );

  const handleGetPedidos = React.useCallback(async () => {
    const response = await GetPedidos(user.id);
    setIsLoading(false);

    const _pedido = response.data as IPedidoType;
    if (_pedido?.Retorno?.status == 0) {
      setPedidos(_pedido);
    } else {
      toast.error(response.data?.Retorno?.msg);
    }
  }, [user.id]);

  const handleVoltar = () => {
    setPedidoSelecionado(PedidoDefault);
    if (element) element.scrollTo({ top: 0 });
  };

  const handleDia = (data_pedido: string) => {
    const date = new Date(data_pedido);
    return date.getDate();
  };

  const handleMes = (data_pedido: string) => {
    const date = new Date(data_pedido);
    return Capitalize(date.toLocaleString('pt-br', { month: 'short' }));
  };

  const handleConcluido = (data_entrega: string) => {
    const date = new Date(data_entrega);
    return date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const handleIsToday = (date: string) => {
    const today = new Date();
    const dataPedido = new Date(date);

    //if (today.toDateString() === dataPedido.toDateString()) return true;
    if (
      today.getFullYear() === dataPedido.getFullYear() &&
      today.getMonth() === dataPedido.getMonth() &&
      today.getDate() === dataPedido.getDate()
    ) {
      return true;
    }

    return false;
  };

  const checkNewOrders = React.useCallback(() => {
    const Index = PEDIDOS?.Pedidos.findIndex((p) => p.importado === 0 || p.importado === 99);

    if (Index !== -1) {
      handleGetPedidos();
      return false;
    } else {
      if (pedidoSelecionado.numero_pedido > 0) {
        const pedido = PEDIDOS?.Pedidos.filter((item) => item.numero_pedido === pedidoSelecionado.numero_pedido);
        if (pedido && pedido.length > 0) {
          handleItemSelected(pedido[0]);
        }
      }
      return true;
    }
  }, [PEDIDOS?.Pedidos, handleGetPedidos, handleItemSelected, pedidoSelecionado.numero_pedido]);

  React.useEffect(() => {
    if (!PEDIDOS?.Pedidos || !firstEntrance.current) return;
    if (PEDIDOS?.Pedidos.length > 0) {
      // pre-seleciona o pedido
      if (param === 'block|true' && PEDIDOS.Pedidos.length > 0) {
        firstEntrance.current = false;
        handleItemSelected(PEDIDOS.Pedidos[0]);
      }
    }
  }, [PEDIDOS?.Pedidos, handleItemSelected, param]);

  // para atualizar o status quando o usuário esta dentro do detalhamento do pedido
  React.useEffect(() => {
    if (!PEDIDOS?.Pedidos || pedidoSelecionado.numero_pedido === 0) return;

    const _pedidoSelecionado = PEDIDOS.Pedidos.filter((p) => p.numero_pedido === pedidoSelecionado.numero_pedido);
    if (_pedidoSelecionado.length > 0) handleItemSelected(_pedidoSelecionado[0]);
  }, [PEDIDOS?.Pedidos, handleItemSelected, pedidoSelecionado.numero_pedido]);

  // timer pra validar os status do pedido enquanto não é confirmado
  React.useEffect(() => {
    const interval = setInterval(() => {
      const stopInterval = checkNewOrders();
      if (stopInterval) clearInterval(interval);
    }, 10000);

    return () => clearInterval(interval);
  }, [checkNewOrders]);

  React.useEffect(() => {
    handleGetPedidos();
  }, [handleGetPedidos]);

  React.useEffect(() => {
    calculaTotais;
  }, [calculaTotais]);

  return (
    <div className="container" style={{ minHeight: '350px' }}>
      {pedidoSelecionado.numero_pedido == 0 &&
        PEDIDOS?.Pedidos.map((item) => {
          return (
            <div
              className="pedidos-container bntWhite btn-shadow"
              key={item.numero_pedido}
              onClick={() => handleItemSelected(item)}
            >
              <div className="pedidos-data-pedido">
                {handleIsToday(item.datahora_pedido) && (
                  <>
                    <h4>Hoje</h4>
                    {/* <h5>Hoje</h5> */}
                  </>
                )}
                {!handleIsToday(item.datahora_pedido) && (
                  <>
                    <h4>{handleDia(item.datahora_pedido)}</h4>
                    <h5>{handleMes(item.datahora_pedido)}</h5>
                  </>
                )}
              </div>

              <div className="pedidos-numero-pedido">
                {' '}
                <i
                  className="material-icons"
                  style={{
                    // fontSize: item.kds_entregue === 0 ? 12 : 16,
                    // color: item.kds_pendente === 1 ? '#f3713b' : item.kds_entregue === 0 ? '#00b4a4' : '#00b4a4',
                    fontSize: item.importado === 0 || item.importado === 99 ? 12 : 16,
                    color: item.importado === 0 || item.importado === 99 ? '#f3713b' : '#00b4a4',
                    float: 'right',
                    marginTop: 5,
                    fontWeight: 800,
                  }}
                >
                  {/* {item.kds_entregue === 0 ? 'circle' : 'task_alt'} */}
                  {item.importado === 0 || item.importado === 99 ? 'circle' : 'task_alt'}
                </i>
                <p>
                  {/* {item.kds_entregue === 1 && ( */}
                  {item.importado === 123 && (
                    <>
                      {/* Pedido Concluído: <span className="to-right">{handleConcluido(item.kds_entregue_datahora)}</span> */}
                      Concluído <span className="to-right">{handleConcluido(item.importado_data)}</span>
                    </>
                  )}
                  {/* {item.kds_entregue === 0 && ( */}
                  {item.importado === 321 && (
                    <>
                      Previsão de entrega{' '}
                      <span className="to-right">{handlePrevisao(item.importado_data).toString()}</span>
                      {/* Previsão de entrega <span className="to-right">{handlePrevisao(item.datahora_pedido)}</span> */}
                    </>
                  )}
                  {dadosApp.TipoApp === 'DELIVERY' && (
                    <>
                      {item.agendado === 1 ? 'Agendado: ' : 'Previsão de entrega:'}{' '}
                      <span className="to-right">
                        {item.agendado === 1
                          ? FormatDateTime(item.previsao_entrega).toString()
                          : handlePrevisao(item.datahora_pedido).toString()}
                      </span>
                    </>
                  )}
                  {dadosApp.TipoApp === 'BALCAO' && (
                    <>
                      Hora do Pedido:{' '}
                      <span className="to-right">{handlePrevisao(item.datahora_pedido).toString()}</span>
                    </>
                  )}
                </p>
                {/* {item.importado === 0 && <h4>{handlePrevisao(item.datahora_pedido)}</h4>} */}

                {modulo === 'BALCAO' && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4>
                      <span className="to-right1">
                        {item.senha_pedido === 0
                          ? 'gerando...'
                          : 'Senha: ' + item.senha_pedido}
                      </span>
                    </h4>
                    <span style={{ color: 'gray', fontWeight: 500, fontSize: 12 }}>Pedido: {item.numero_pedido}</span>
                  </div>
                )}

                {modulo !== 'BALCAO' && (
                  <h4 style={{ color: 'rgb(0, 55, 107)' }}>
                    Pedido: <span className="to-right1">{item.numero_pedido}</span>
                  </h4>
                )}
                <span style={{ color: 'gray', float: 'left' }}>{FormataValor(item.total_com_servico)}</span>
                <span
                  className="to-right"
                  style={{
                    color: item.importado === 99 ? 'red' : 'gray',
                    fontSize: item.importado === 99 ? 14 : 16,
                    lineHeight: item.importado === 99 ? 2 : 1.7,
                  }}
                >
                  {item.importado === 0 ? 'Pendente' : item.importado === 99 ? 'Pgto. Pendente' : 'Confirmado'}
                </span>
              </div>
            </div>
          );
        })}

      {pedidoSelecionado.numero_pedido > 0 && (
        <div style={{ background: 'white', position: 'sticky', top: '0', height: '75px', zIndex: 99 }}>
          <Button
            text={
              modulo === 'BALCAO' && pix && !pago
                ? 'Pedido: ' + pedidoSelecionado.numero_pedido
                : modulo === 'BALCAO'
                  ? 'Senha: ' + pedidoSelecionado.senha_pedido
                  : 'Pedido: ' + pedidoSelecionado.numero_pedido
            }
            icon="chevron_left"
            iconAlign="left"
            className="btnWhite btn-shadow"
            onClick={() => handleVoltar()}
          />
        </div>
      )}
      {pedidoSelecionado.numero_pedido > 0 && (
        <>
          {dadosApp.TipoApp === 'BALCAO' && pago && (
            <div style={{ textAlign: 'center', padding: '40px 0 30px 0' }}>
              <QRCode value={QRCodeValue ? QRCodeValue : ''} size={128} />
            </div>
          )}
          <Timeline pedidoSelecionado={pedidoSelecionado} shadow padTop={40} padBottom={25} title={false} />
        </>
      )}

      <div
        className={pedidoSelecionado.numero_pedido > 0 ? 'cardShadow ' : ''}
        style={{ marginTop: 20, marginBottom: 20 }}
      >
        {pedidoSelecionado.numero_pedido > 0 && (
          <>
            {/* <div
              className="main"
              style={{ padding: '15px 15px', overflow: 'hidden', borderBottom: '1px solid #ebebeb' }}
            >
              <div>
                Data do Pedido <span style={{ float: 'right', fontSize: '14px' }}>{pedidoSelecionado.data}</span>
              </div>
              <div style={{ paddingTop: '10px' }}>
                Pagamento{' '}
                <span style={{ float: 'right', fontSize: '14px' }}>{Capitalize(pedidoSelecionado.pagamento[0])}</span>
              </div>
            </div> */}

            {pedidoSelecionado?.endereco?.length > 5 && modulo !== 'BALCAO' && (
              <div
                className="main"
                style={{
                  padding: '0px 15px 15px 15px',
                  overflow: 'hidden',
                  borderBottom: '1px solid #ebebeb',
                  textAlign: 'center',
                }}
              >

                <p className="mb-2" style={{ fontSize: 12, color: 'gray' }}>
                  Endereço de entrega
                </p>

                <div>{Capitalize(pedidoSelecionado.endereco)}</div>
              </div>
            )}
          </>
        )}
        <p className="padTop20" style={{ fontSize: 12, color: 'gray', textAlign: 'center' }}>
          {pedidoSelecionado.numero_pedido > 0
            ? 'Itens'
            : PEDIDOS?.Pedidos.length === 0 // eslint-disable-next-line prettier/prettier
              ? 'Nenhum pedido realizado' // eslint-disable-next-line prettier/prettier
              : ''}
        </p>
        {pedidoSelecionado.numero_pedido > 0 &&
          PEDIDOS?.Detalhes.filter((p) => p.Produto.numero_pedido == pedidoSelecionado.numero_pedido).map(
            (item, index) => (
              <ul key={'item' + index} className="clearfix" style={{ padding: '10px 15px 0' }}>
                <li>
                  <span style={{ fontSize: '16px', marginLeft: '10px', color: '#3f3e3e', float: 'right' }}>
                    {FormataValor(item.VTotal)}
                  </span>
                  <p style={{ fontSize: '14px', margin: '0', textAlign: 'left' }}>
                    {!item.Produto.quantidade_texto.includes('/')
                      ? item.Produto.quantidade_texto + 'x '
                      : item.Produto.quantidade_texto}
                    {''}
                    &#8287; {Capitalize(item.Produto.descricao_produto)}
                  </p>
                  {item.ItensMontagemText.length > 0 && (
                    <p style={{ fontSize: '14px', margin: '7px 0', color: '#717171', textAlign: 'left' }}>
                      {Capitalize(
                        item.ItensMontagemText.replaceAll('0,333', '1/3')
                          .replaceAll('0,5', '1/2')
                          .replaceAll('0,250', '1/4'),
                      )}
                    </p>
                  )}
                  {item.Produto.observacao_pedido.length > 0 && (
                    <p style={{ fontSize: '14px', margin: '7px 0', color: '#717171', textAlign: 'left' }}>
                      {Capitalize('Obs. ' + item.Produto.observacao_pedido)}
                    </p>
                  )}
                </li>
              </ul>
            ),
          )}

        {pedidoSelecionado.numero_pedido > 0 && (
          <div className="main" style={{ padding: '0 15px', borderTop: '1px solid #ebebeb', overflow: 'hidden' }}>
            <ValoresTotais
              origin={''}
              subtotal={subTotal}
              taxa={taxa}
              total={total}
              isDelivery={dadosApp.TipoApp === 'DELIVERY'}
            />
          </div>
        )}
      </div>
      {isLoading && (
        <Modal
          title=""
          isFooter={false}
          visibility={isLoading ? 'block' : 'none'}
          param={{ msg: 'Aguarde...' }}
          page="LOADING"
          customPosition="loading-modal"
        />
      )}
    </div>
  );
};

export default Pedidos;
